/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamProgramovaFaze extends GContentBase<SeznamProgramovaFazeObj> {
        private seznamObj: SeznamProgramovaFazeObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamProgramovaFazeObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamProgramovaFaze",
                contentCaption: "jres:33000690", //RC 33000690 : Programové fáze
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{nazev}"
                },
                gridSettings: {
                    columnOrder: "faze,faze_txt,vzkaz,typ_ag_txt,submodel,subsyst,pocet_lic,pocet_adm,priz_adm,priz_ext,priz_exu"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamProgramovaFazeObj extends GAdmSeznamBase {

        create() {
            
        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailProgramovaFaze", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailProgramovaFaze",
                newRecord: isNew,
                faze: isNew == true ? null : data.faze
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actAdmUrlWeboveAplikace: {
                    caption: "jres:33000682",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.urlProgramoveFaze();
                    }
                },
                actAdmUrlAdresaDalsiInformaceFaze: {
                    caption: "jres:33000684",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.urlDalsiInformaceFaze();
                    }
                },
                actProgramoveInstance: {
                    caption: "jres:29929931",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.programoveInstance();
                    }
                },
                actVzkazy: {
                    caption: "jres:33000696", //RC 33000696 : Vzkazy pro uživatele pro tuto fázi
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.vzkazyProUzivatele();
                    }
                },
                actParametryProFaze: {
                    caption: "jres:33000697",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.parametryFaze();
                    }
                },
                actZastupyFaze: {
                    caption: "jres:33000700",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.zastupyFaze();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actProgramoveInstance },
                        { action: this.cnt.actions.actAdmUrlWeboveAplikace },
                        { action: this.cnt.actions.actAdmUrlAdresaDalsiInformaceFaze },
                        { action: this.cnt.actions.actParametryProFaze },
                        { action: this.cnt.actions.actZastupyFaze },
                        { action: this.cnt.actions.actVzkazy }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "actProgramoveInstance*",
                "actAdmUrlWeboveAplikace*",
                "actAdmUrlAdresaDalsiInformaceFaze*",
                "actParametryProFaze*",
                "actZastupyFaze*",
                "actVzkazy*"
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.ProgramovaFaze.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actAdmUrlWeboveAplikace?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actAdmUrlAdresaDalsiInformaceFaze?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actVzkazy?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actProgramoveInstance?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actParametryProFaze?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actZastupyFaze?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.faze),
                nazev: data["faze_txt"]
            }
        }

        private urlProgramoveFaze() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmUrlWeboveAplikace"], { faze: activeRow.faze, Id: "SeznamAdmUrlWeboveAplikace" })
        }

        private urlDalsiInformaceFaze() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmUrlAdresaDalsiInformaceFaze"], { faze: activeRow.faze, Id: "SeznamAdmUrlAdresaDalsiInformaceFaze" })
        }

        private programoveInstance() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamProgramovaInstance"], { faze: activeRow.faze, Id: "SeznamProgramovaInstance" })
        }

        private vzkazyProUzivatele() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Ozn.WebClient.GMessageList", { faze: activeRow.faze }])
        }

        private parametryFaze() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmParametrGlobal"], { Id: "SeznamAdmParametrGlobal", faze: activeRow.faze, uroven_cfg: 38 })
        }

        private zastupyFaze() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamZastup", { faze: activeRow.faze }], { ID: "SeznamZastup" })
        }
    }
}